import React from 'react'

const Footer = () => {
  return (
     <footer className="w3-container w3-padding-16" style={{ marginTop: 32 }}>
      Powered by{" "}
      <a
        href="https://www.w3schools.com/w3css/default.asp"
        title="W3.CSS"
        target="_blank"
        className="w3-hover-text-green"
      >
        w3.css
      </a>
    </footer>
  )
}

export default Footer